import classnames from 'classnames'
import * as React from 'react'

import { Box, BoxProps } from '../box'
import { DialogDragContext } from './hooks'

/**
 * Public props for the component
 */
export type DialogBoxProps = BoxProps

interface DialogBoxOwnProps extends DialogBoxProps {
  /**
   * This callback serves as a way to account for the time between dialog close
   * and animation finish. The box isn’t rendered when the dialog closes but we still
   * want to display content when the dialog is closing
   */
  onUnmount?: () => void
}

/**
 * Dialog content container
 */
export function DialogBox({ onUnmount, style, ...props }: React.PropsWithChildren<DialogBoxOwnProps>) {
  const dialogDrag = React.useContext(DialogDragContext)

  // Set up an effect which only calls the unmount callback
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => () => onUnmount?.(), [])

  const dialogBoxStyle = React.useMemo(() => {
    if (dialogDrag.enabled) {
      return { ...style, transform: `translate3d(${dialogDrag.boxPosition.x}px, ${dialogDrag.boxPosition.y}px, 0)` }
    }
    return style
  }, [style, dialogDrag])

  return (
    <Box
      {...props}
      className={classnames('relative z-10 flex max-h-full max-w-full flex-col', props.className)}
      style={dialogBoxStyle}
    >
      {props.children}
    </Box>
  )
}
